import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: '100%',
    minHeight: '100vh',
    margin: 0,
    padding: 0,
    backgroundColor: '#081A1B',
    backgroundImage: 'radial-gradient(circle at top right, #204F51 0%, #081A1B 80%)',
    color: '#fff',
    boxSizing: 'border-box',
    overflow: 'auto',
  },
  content: {
    maxWidth: 460,
    margin: '0 auto',
    padding: theme.spacing(3),
    marginBottom: theme.spacing(2),
    boxSizing: 'border-box',
  },
  card: {
    background: 'rgba(22, 34, 35, 0.78)',
    border: '1px solid rgba(255, 255, 255, 0.18)',
    borderRadius: 24,
    backdropFilter: 'blur(10px)',
    WebkitBackdropFilter: 'blur(10px)',
    boxShadow: '0 14px 30px rgba(0, 0, 0, 0.28)',
    padding: theme.spacing(2),
  },
  title: {
    marginBottom: theme.spacing(2),
    fontWeight: 600,
  },
  muted: {
    color: 'rgba(255, 255, 255, 0.7)',
    fontSize: '0.875rem',
  },
}));

const STR = {
  'lt-LT': {
    profileTitle: 'Profilis',
    prizes: 'Prizai',
    signInToContinue: 'Prisijunkite, kad matytumėte profilį ir prizus.',
  },
  'en-EU': {
    profileTitle: 'Profile',
    prizes: 'Prizes',
    signInToContinue: 'Sign in to view your profile and prizes.',
  },
};

const ProfileLayout = ({ locale, title, children, showGuestHint }) => {
  const classes = useStyles();
  const t = STR[locale] || STR['en-EU'];
  const heading = title ?? t.profileTitle;

  return (
    <Box className={classes.root}>
      <Box className={classes.content}>
        <Typography variant="h5" component="h1" className={classes.title}>
          {heading}
        </Typography>
        {showGuestHint && (
          <Typography className={classes.muted} paragraph>
            {t.signInToContinue}
          </Typography>
        )}
        <Box className={classes.card}>{children}</Box>
      </Box>
    </Box>
  );
};

ProfileLayout.propTypes = {
  locale: PropTypes.string.isRequired,
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
  showGuestHint: PropTypes.bool,
};

ProfileLayout.defaultProps = {
  title: undefined,
  showGuestHint: false,
};

export default ProfileLayout;
export { STR as PROFILE_TEXTS };
